import { API_ENDPOINTS } from 'src/setup/client/api-endpoints';
import HttpClient from 'src/setup/client/http-client';
import {
    TokenInfoPayload,
    SpotOrderPayload,
    SpotActiveOrderCancelPayload,
    SpotConditionalOrderCancelPayload,
    GetSpotLimitOrMarketOrderPayload,
    GetSpotConditionalOrderPayload,
    SpotOrderSettingPayload,
    SpotAllActiveOrderCancelPayload,
    SpotAllConditionalOrderCancelPayload,
} from 'src/types';

// API calls to create order
export function createOrder(body: SpotOrderPayload) {
    return HttpClient.post(
        `${
            body.trigger_price
                ? API_ENDPOINTS.CREATE_SPOT_CONDITIONAL_ORDER
                : API_ENDPOINTS.CREATE_SPOT_ORDER
        }`,
        body,
    );
}

// API calls to fetch kline history
export function klineHistory(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.KLINE_HISTORY}?${queryParams}`);
}

// API calls to fetch index kline history
export function indexKlineHistory(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.INDEX_KLINE_HISTORY}?${queryParams}`);
}

// API calls to fetch server time
export function getServerTime() {
    return HttpClient.get(`${API_ENDPOINTS.SERVER_TIME}`);
}

// API calls to get the token info
export function fetchTokenInfo(body: TokenInfoPayload) {
    return HttpClient.post(`${API_ENDPOINTS.TOKEN_INFO}`, body);
}

// API calls to fetch available spot balances
export function fetchAvailableAssets() {
    return HttpClient.get(`${API_ENDPOINTS.AVAILABLE_SPOT_ASSETS}`);
}

// API calls to fetch active orders
export function fetchActiveOpenOrders(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.SPOT_ACTIVE_OPEN_ORDERS}?${queryParams}`);
}

// API calls to fetch conditional orders
export function fetchConditionalOpenOrders(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.SPOT_CONDITIONAL_OPEN_ORDERS}?${queryParams}`);
}

// API calls to fetch active trade orders
export function fetchActiveTradeOrders(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.SPOT_ACTIVE_TRADE_ORDERS}?${queryParams}`);
}

// API calls to fetch conditional trade orders
export function fetchConditionalTradeOrders(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.SPOT_CONDITIONAL_TRADE_ORDERS}?${queryParams}`);
}

// API calls to fetch my trade orders
export function fetchMyTrades(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.SPOT_MY_TRADES}?${queryParams}`);
}

// API calls to cancel active spot order
export function cancelActiveOrder(body: SpotActiveOrderCancelPayload) {
    return HttpClient.post(`${API_ENDPOINTS.SPOT_ACTIVE_ORDER_CANCEL}`, body);
}

// API calls to cancel conditional spot order
export function cancelConditionalOrder(body: SpotConditionalOrderCancelPayload) {
    return HttpClient.post(`${API_ENDPOINTS.SPOT_CONDITIONAL_ORDER_CANCEL}`, body);
}

// API calls to get sub orders of limit or market spot order
export function getLimitOrMarketOrderDetail(body: GetSpotLimitOrMarketOrderPayload) {
    return HttpClient.post(`${API_ENDPOINTS.GET_SPOT_LIMIT_MARKET_ORDER}`, body);
}

// API calls to get sub orders of conditional spot order
export function getConditionalOrderDetail(body: GetSpotConditionalOrderPayload) {
    return HttpClient.post(`${API_ENDPOINTS.GET_SPOT_CONDITIONAL_ORDER}`, body);
}

// API calls to fetch order setting
export function fetchOrderSetting() {
    return HttpClient.post(`${API_ENDPOINTS.GET_SPOT_ORDER_SETTING}`, {});
}

// API calls to set order setting
export function setOrderSetting(body: SpotOrderSettingPayload) {
    return HttpClient.post(`${API_ENDPOINTS.SET_SPOT_ORDER_SETTING}`, body);
}

// API calls to cancel all acttive orders
export function cancelAllActiveOrders(body: SpotAllActiveOrderCancelPayload) {
    return HttpClient.post(`${API_ENDPOINTS.CANCEL_ALL_SPOT_LIMIT_ORDERS}`, body);
}

// API calls to cancel all conditional orders
export function cancelAllConditionalOrders(body: SpotAllConditionalOrderCancelPayload) {
    return HttpClient.post(`${API_ENDPOINTS.CANCEL_ALL_SPOT_CONDITIONAL_ORDERS}`, body);
}
